"use client";

import { useActiveFY } from "@/hooks/useActiveFY";

export default function FyBootstrap() {
  useActiveFY();
  return null;
}
